import { render, staticRenderFns } from "./edit-good-price.vue?vue&type=template&id=2c2e0e33&"
import script from "./edit-good-price.vue?vue&type=script&lang=js&"
export * from "./edit-good-price.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports